import React from "react"

import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import FormParentSelector from "./form-parent-selector"

type Props = {
    form                    : FormManager

    parentProjectId?        : ID | null

    allowRootSelection?     : boolean
    filterProjects?         : any[]

    onParentSelected        : func
}

export default function ParentSelector(props:Props) {
    const allowRootSelection = !_.isNil(props.allowRootSelection) ? props.allowRootSelection : gd.ac.check.createRootProject()

    const filterProjects: any[] = props.filterProjects || _.map(gd.session.projects.models, project =>({
        item            : project,
        notSelectable   : !project.canCreateProject()
    }))

    return <FormParentSelector form                 = {props.form}
                               projectId            = {props.parentProjectId}
                               allowRootSelection   = {allowRootSelection}
                               filterProjects       = {filterProjects}
                               onParentSelected     = {props.onParentSelected}/>
}
